module.exports = __webpack_public_path__ + "pc/static/img/icon32.f9f1f6b3.png";